import {useCallback, type ErrorInfo} from 'react';
import {useReportError} from '../../data-layer-client/ReportError';
import {useAnalytics} from '../../data-layer-client/useAnalytics';
import {EmbeddedError} from '../../utils/errorHandling';

export type ReportConnectRenderError = (
  error: Error,
  errorInfo: ErrorInfo,
) => void;

/**
 * Report a connect render error. These are generally alerted on and signal that the app has reached an incoverable render state
 */
export const useReportConnectRenderError = () => {
  const analytics = useAnalytics();
  const reportError = useReportError();

  const connectReportError: ReportConnectRenderError = useCallback(
    (error, errorInfo) => {
      reportError(
        error,
        {type: EmbeddedError.ReactError},
        {
          componentStack: errorInfo.componentStack,
        },
      );

      analytics.track('submerchant_surfaces_render_error', {
        component_stack: errorInfo?.componentStack,
        error_message: error?.message,
        error_stack: error?.stack,
      });
    },
    [analytics, reportError],
  );

  return connectReportError;
};
